/**
 * Created by claudio iozzia on 29/06/2017.
 */
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {siPrefix} from "../../../../common/siPrefix";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {Utils} from "../../../../common/utils";
import {IC_fsw} from "../../../../models/IC_fsw";

export function calculate_voutUpperBound(ic: Ic, spec: IAppSpec): number {
  const dMax: number = Math.min(new IC_fsw(ic).dMax, 0.98);
  const _vin = spec.spec.value.input;
  const vinMin_dc = _vin.min;
  const vinMax_dc = _vin.max;

  let vOutUpperBound: number;

  const isAttendibileVinMin: boolean = !spec.spec.note.input.min.hasError && Utils.isValueReal(_vin.min);
  const isAttendibileVinMax: boolean = !spec.spec.note.input.max.hasError && Utils.isValueReal(_vin.max);

  if (isAttendibileVinMin) {
    vOutUpperBound = (ic.vout_max && ic.vout_min && ic.vout_max === ic.vout_min) ? ic.vout_max : vinMin_dc * dMax;
  } else if (isAttendibileVinMax) {
    vOutUpperBound = (ic.vout_max && ic.vout_min && ic.vout_max === ic.vout_min) ? ic.vout_max : vinMax_dc * dMax;
  } else {
    vOutUpperBound = ic.vout_max;
  }

  if (ic.vout_max < vOutUpperBound) {
    vOutUpperBound = ic.vout_max;
  }

  vOutUpperBound = ValueFormatter.scale(vOutUpperBound, siPrefix.unit, 1, 'f');

  return vOutUpperBound;
}
